import { gql } from '@apollo/client'

const GET_BOOKING_LIMIT_OPTIONS = gql`
  query GetBookingLimitOptions($id: ID!) {
    coach(id: $id) {
      bookingLimit
      bookingCutoff
      canStudentCancel
      cancellationPolicy
    }
    bookingLimitOptions {
      label
      value
    }
    bookingCutoffOptions {
      label
      value
    }
  }
`

const SET_BOOKING_LIMIT = gql`
  mutation updateCoachPreferences($input: CoachPreferencesInput!) {
    updateCoachPreferences(input: $input) {
      success
      message
      coach {
        bookingLimit
        bookingCutoff
        canStudentCancel
        cancellationPolicy
      }
    }
  }
`
export { GET_BOOKING_LIMIT_OPTIONS, SET_BOOKING_LIMIT }
